import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import * as rpBreakpoints from 'rp-mq-breakpoints';

import { getGBDateNow } from '../helpers/dateHelper';
import NavigationList from './NavigationList';

export class SecondaryNavigation extends PureComponent {
    constructor(props) {
        super(props);
        this.getNavigationList = this.getNavigationList.bind(this);
        this.toggleMenu = this.toggleMenu.bind(this);
        this.onBreakpointChange = this.onBreakpointChange.bind(this);
        this.getIndexRoute = () => ({
            label: 'Going & Non-runners',
            link: '/',
        });
        this.state = {
            isActive: false,
        };
    }
    componentWillMount() {
        window.addEventListener('rpBreakpointsSwitch', this.onBreakpointChange);
    }
    componentWillUpdate(nextProps, nextState) {
        if (nextState.isActive) {
            window.addEventListener('click', this.toggleMenu, false);
        } else {
            window.removeEventListener('click', this.toggleMenu, false);
        }
    }
    onBreakpointChange(e) {
        const { breakpointCodes } = rpBreakpoints;
        const isActive = this.state.isActive;
        const wideBreakpoints = [
            breakpointCodes.MEDIUM,
            breakpointCodes.WIDE,
            breakpointCodes.EXTRA_WIDE,
        ];

        if (isActive && wideBreakpoints.includes(e.detail.breakpoint.code)) {
            this.setState({ isActive: false });
        }
    }
    getNavigationList() {
        const daysCount = 7;
        const today = getGBDateNow();
        const todayFormatted = today.format('YYYY-MM-DD');
        const tomorrowFormatted = today.clone().add(1, 'days').format('YYYY-MM-DD');

        const selectedDate = this.props.route;
        const isTodaySelected =
            todayFormatted === selectedDate
            || selectedDate === '/';

        const navigationList = [
            {
                label: 'Today',
                date: todayFormatted,
                link: '/',
                isSelected: isTodaySelected,
            },
            {
                label: 'Tomorrow',
                date: tomorrowFormatted,
                link: `/${tomorrowFormatted}`,
                isSelected: tomorrowFormatted === selectedDate,
            },
        ];

        for (let i = 2; i < daysCount; i += 1) {
            const futureDate = today.clone().add(i, 'days');
            const futureDateFormatted = futureDate.format('YYYY-MM-DD');
            const futureDateLabel = futureDate.format('ddd D');
            navigationList.push({
                label: futureDateLabel,
                date: futureDateFormatted,
                link: `/${futureDateFormatted}`,
                isSelected: futureDateFormatted === selectedDate,
            });
        }

        return navigationList;
    }
    toggleMenu(e) {
        e.stopPropagation();
        this.setState({ isActive: !this.state.isActive });
    }
    render() {
        return (
            <NavigationList
                navItems={this.getNavigationList()}
                indexRoute={this.getIndexRoute()}
                toggleMenu={this.toggleMenu}
                isActive={this.state.isActive}
            />
        );
    }
}

SecondaryNavigation.propTypes = {
    route: PropTypes.string.isRequired,
};

export default SecondaryNavigation;



// WEBPACK FOOTER //
// ./src/js/secondaryNavigation/SecondaryNavigation.jsx